import { createContext } from 'react'

const FunkGoContext = createContext(null)

FunkGoContext.displayName = 'FunkGoContext'

export default FunkGoContext